import { Switch, Tag, Tooltip, Typography } from '@neo4j-ndl/react';

type Props = {
  data: boolean;
  onChange: (value: boolean) => void;
};

const label = 'Toggle to enable multiple databases in instance';

export const MultiDatabaseField = ({ data, onChange }: Props) => (
  <div className="flex flex-row items-center justify-between py-2">
    <div className="flex flex-col gap-2">
      <div className="flex flex-row items-center gap-2">
        <Typography variant="subheading-medium">Multiple databases</Typography>
        <Tag size="small">Early Access Preview</Tag>
      </div>

      <Typography variant="body-medium" as="div" className="text-neutral-text-weak">
        Use multiple databases in a single instance
      </Typography>
    </div>
    <div>
      <Tooltip type="simple" isPortaled={false}>
        <Tooltip.Trigger>
          <Switch
            htmlAttributes={{
              'aria-label': label,
              'data-testid': 'multidb-switch',
            }}
            ariaLabel={label}
            isChecked={data}
            onChange={(e) => onChange(e.target.checked)}
          />
        </Tooltip.Trigger>
      </Tooltip>
    </div>
  </div>
);
